var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "#FEFCE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6663 22V20.6667C18.6663 19.9594 18.3854 19.2811 17.8853 18.781C17.3852 18.281 16.7069 18 15.9997 18H11.9997C11.2924 18 10.6142 18.281 10.1141 18.781C9.61396 19.2811 9.33301 19.9594 9.33301 20.6667V22",
    stroke: "#D08700",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 15.3333C15.4724 15.3333 16.6663 14.1394 16.6663 12.6667C16.6663 11.1939 15.4724 10 13.9997 10C12.5269 10 11.333 11.1939 11.333 12.6667C11.333 14.1394 12.5269 15.3333 13.9997 15.3333Z",
    stroke: "#D08700",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.667 13.3335V17.3335",
    stroke: "#D08700",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 15.3335H18.667",
    stroke: "#D08700",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyContact);
export default __webpack_public_path__ + "static/media/emergencyContact.5b665356cc89b4d18cbbef9bf82f00b0.svg";
export { ForwardRef as ReactComponent };